module.exports = __webpack_public_path__ + "static/media/contact.2b84d892.svg";